import Icon from '../components/Icon.vue'

Icon.register({"toolbox":{"width":512,"height":512,"paths":[{"d":"M502.6 214.6L457.4 169.4C451.4 163.4 443.2 160 434.8 160H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V160H77.3C68.8 160 60.6 163.4 54.6 169.4L9.4 214.6C3.4 220.6 0 228.8 0 237.3V320H128V304C128 295.2 135.2 288 144 288H176C184.8 288 192 295.2 192 304V320H320V304C320 295.2 327.2 288 336 288H368C376.8 288 384 295.2 384 304V320H512V237.3C512 228.8 508.6 220.6 502.6 214.6zM320 160H192V96H320V160zM384 368C384 376.8 376.8 384 368 384H336C327.2 384 320 376.8 320 368V352H192V368C192 376.8 184.8 384 176 384H144C135.2 384 128 376.8 128 368V352H0V448C0 465.7 14.3 480 32 480H480C497.7 480 512 465.7 512 448V352H384V368z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toolbox.js
// module id = I3Xy
// module chunks = 0